const ICONS = {
  success: '<svg class="toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
  error: '<svg class="toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
  warning:
    '<svg class="toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m10.29 3.86-8.6 14.86A2 2 0 0 0 3.4 22h17.2a2 2 0 0 0 1.71-3.28L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
  info: '<svg class="toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
};

// Trusted, developer-controlled markup for the dismiss button.
const CLOSE_ICON =
  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

function toastContainer() {
  let container = document.getElementById("toast-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "toast-container";
    container.setAttribute("aria-live", "polite");
    document.body.appendChild(container);
  }
  return container;
}

// showToast({ message, type, duration })
//   message  (required) — text shown to the user; rendered as textContent.
//   type     (required) — success | error | warning | info.
//   duration (optional) — auto-dismiss after N ms. When it isn't a positive,
//                         finite number the toast stays until dismissed.
// Returns a dismiss() function so callers can close the toast programmatically.
window.showToast = function ({ message, type, duration } = {}) {
  if (!message || !type) {
    console.error("showToast: `message` and `type` are required.", { message, type });
    return () => {};
  }

  const container = toastContainer();
  const autoDismiss = Number.isFinite(duration) && duration > 0;

  const toast = document.createElement("div");
  toast.className = `toast toast--${type}`;
  // Errors and warnings interrupt; success/info are announced politely.
  toast.setAttribute("role", type === "error" || type === "warning" ? "alert" : "status");
  toast.style.cssText = "opacity:0; transform:translateY(-6px); transition:opacity 200ms, transform 200ms;";

  if (ICONS[type]) toast.insertAdjacentHTML("beforeend", ICONS[type]);

  // textContent (not innerHTML) — message may contain user-supplied data.
  const messageEl = document.createElement("span");
  messageEl.className = "toast__message";
  messageEl.textContent = message;
  toast.appendChild(messageEl);

  let dismissed = false;
  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    toast.style.opacity = "0";
    toast.style.transform = "translateY(-6px)";
    setTimeout(() => toast.remove(), 220);
  };

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "toast__close";
  closeBtn.setAttribute("aria-label", "Dismiss");
  closeBtn.insertAdjacentHTML("beforeend", CLOSE_ICON);
  closeBtn.addEventListener("click", dismiss);
  toast.appendChild(closeBtn);

  let bar = null;
  if (autoDismiss) {
    const progress = document.createElement("div");
    progress.className = "toast__progress";
    bar = document.createElement("div");
    bar.className = "toast__progress-bar";
    progress.appendChild(bar);
    toast.appendChild(progress);
  }

  container.appendChild(toast);

  // Entrance
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.style.opacity = "1";
      toast.style.transform = "translateY(0)";
    });
  });

  if (autoDismiss) {
    if (bar) {
      bar.style.transition = `width ${duration}ms linear`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          bar.style.width = "0%";
        });
      });
    }

    setTimeout(dismiss, duration);
  }

  return dismiss;
};

// Surface server-rendered .flash-toast elements as toasts. Each element's
// data attributes map to showToast's arguments; anything omitted (e.g.
// data-duration) falls back to the function's own default.
function showFlashToasts() {
  document.querySelectorAll(".flash-toast").forEach((el) => {
    const { message, type, duration } = el.dataset;
    if (message) {
      window.showToast({ message, type, duration: duration ? Number(duration) : undefined });
    }
    el.remove();
  });
}

document.addEventListener("turbo:load", showFlashToasts);
document.addEventListener("turbo:render", showFlashToasts);
